import type { Hours } from "@freightsimple/generated-dashboard-openapi-client/models/Hours";

// Submitting the hours the shipment already has changes nothing: the backend
// skips it without regenerating the bill of lading, so there is nothing to
// confirm and nothing for the customer to reprint.
export function changeDeliveryHoursIsUnchanged(
  currentHours: Hours,
  newHours: Hours,
): boolean {
  return (
    currentHours.openFrom === newHours.openFrom &&
    currentHours.openUntil === newHours.openUntil
  );
}
